import styled from 'styled-components';
import Box from './base/Box';

const FormGroup = styled(Box)`
  margin: 8px 0;
  & button {
    width: 100%;
    height: 50px;
    font-size: 18px;
    transition: all 0.2s ease-in-out;
    &:hover {
      background-color: ${({ theme }) => theme.colors.secondary};
    }
  }
  & label,
  & span {
    font-size: 13px;
  }
  & span {
    color: red;
  }
`;

export default FormGroup;
